const ATTRIBUTE_PROPAGATION_FLAG_TYPES = {
  CUSTOM: 'CUSTOM',
  HYBRID: 'HYBRID',
  BEST: 'BEST',
};

const ATTRIBUTE_PROPAGATION_FLAG_TYPES_OPTIONS = Object.entries(
  ATTRIBUTE_PROPAGATION_FLAG_TYPES,
).map(([value, label]) => ({
  label,
  value,
}));

export default ATTRIBUTE_PROPAGATION_FLAG_TYPES;
export { ATTRIBUTE_PROPAGATION_FLAG_TYPES_OPTIONS };
